module.exports = __webpack_public_path__ + "static/media/photography.f66fb834.png";